import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IFormController, IRootScopeService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Autentisering} from "felles/tjenester/Autentisering";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {InnlastingsindikatorKontroller} from "web/moduler/basis/direktiver/innlastingsindikator";
import {NyGruppeOgBrukerModell} from "./OpprettGruppeKontroller";
import {LisensavtaleDialog} from "../../gruppe/modale/lisensavtale/lisensavtaleDialog";

export class OpprettGruppeSteg2Kontroller {
    static regNavn = "OpprettGruppeSteg2Kontroller";

    static forInjisering() {
        return [
            regNavn.ng.ui.$state,
            regNavn.ng.$rootScope,
            Autentisering.regNavn,
            GruppeRessurs.regNavn,
            LisensavtaleDialog.regNavn,
            WebNavigasjon.regNavn,
            OpprettGruppeSteg2Kontroller
        ]
    }

    constructor(private $state: StateService,
                private $rootScope: IRootScopeService,
                private autentisering: Autentisering,
                private gruppeRes: GruppeRessurs,
                private lisensavtaleDialog: LisensavtaleDialog,
                private navigasjon: WebNavigasjon) {
        this.modell = $state.get("forside.opprettGruppe").data.modell;
        if (!this.modell) {
            this.navigasjon.gåTilRegistrerGruppeOgBruker();
            return;
        }
        //todo kun vise mal for aktuelle språk ?
        this.malgrupper = this.gruppeRes.finnMalgrupper();
    }

    lagrer = false;
    malgrupper: l.EnkelGruppeModell[];

    modell: NyGruppeOgBrukerModell;

    godtaLisens() {
        if (this.modell.spesifikasjon.avtale.lisensAkseptert !== true)
            this.lisensavtaleDialog.visLisensavtaleDialog(akseptert => this.modell.lisensavtaleAkseptert(akseptert));
    }

    opprettGruppe(skjema: IFormController) {
        this.lagrer = true;
        this.$rootScope.$emit(InnlastingsindikatorKontroller.vis_innlasting);
        this.gruppeRes.opprettGruppeOgBruker(this.modell.somSpesifikasjon()).$promise
            .then(medlem => this.autentisering.autentiser({
                    brukernavn: this.modell.spesifikasjon.bruker.epost,
                    passord: this.modell.spesifikasjon.bruker.passord
                })
            )
            .then(() => {
                this.reset();
                this.navigasjon.gåTilStartsiden();
            })
            .finally(() => {
                this.lagrer = false;
                this.$rootScope.$emit(InnlastingsindikatorKontroller.innlasting_ferdig);
                skjema.$setPristine()
            });
    }

    private reset() {
        this.$state.get("forside.opprettGruppe").data.modell = null;
    }

}
